import { Component, inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { RightBridgeApiService } from '../../../services/right-bridge-api.service';
import { ClipboardService } from 'ngx-clipboard';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-alerts-dialog',
  templateUrl: './alerts-dialog.component.html',
  styleUrls: ['./alerts-dialog.component.scss'],
  imports: [MatDialogModule, MatButtonModule, MatIconModule, MatTooltipModule],
})
export class AlertsDialogComponent {
  private clippy = inject(ClipboardService);
  dialogRef = inject<MatDialogRef<AlertsDialogComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);
  private rbs = inject(RightBridgeApiService);
  private snacky = inject(MatSnackBar);

  cancel() {
    this.dialogRef.close('cancel');
    this.dialogRef.afterClosed().subscribe(() => {
      this.dialogRef = null;
    });
  }

  decryptValue(value: string) {
    this.rbs.decryptValue(value).subscribe({
      next: resp => {
        if (resp['resultString']) {
          this.clippy.copy(resp['resultString']);
          this.snacky.open(
            `Value: ${resp['resultString']} copied to clipboard!`,
            'Close',
            {
              duration: 5000,
            }
          );
        }
      },
      error: err => {
        console.error('ERROR: ', err);
        this.snacky.open(
          `Oops! Something went wrong. Please try again.`,
          'Close',
          {
            duration: 4000,
          }
        );
      },
    });
  }
}
